import coflictResolutionModal from "./locales/en.json";

export const CONFLICT_RESOLUTION_MODAL_NS = "conflictResolutionModal" as const;

export const ConflictResolutionModalTranslations = {
  en: {
    [CONFLICT_RESOLUTION_MODAL_NS]: {
      ...coflictResolutionModal,
    },
  },
};
